import React from 'react';
import {ReactComponent as StarsIcon} from '../../../../assets/icons/Stars.svg';
import {ReactComponent as ToReleaseIcon} from '../../../../assets/icons/to-release.svg';
import AvatarSpectator from '../../../../assets/images/avatars/avatar-spectator.png';
import AvatarUser from '../../../../assets/images/avatars/avatar-users.png';
import {ReactComponent as UseAddIcon} from '../../../../assets/icons/user-add.svg';
import {ReactComponent as SettingsIcon} from '../../../../assets/images/profile/Menu/project3.svg';

import './Employees.scss';
import Rating from '../../Rating';
import {IconButtonMUI} from '../../../../shared';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";

const Employees = ({
                       name,
                       position,
                       phone,
                       status,
                       projectsAtWork,
                       email,
                       mark,
                       review,
                       avatar,
                       id,
                       handleId,
                       employeeId,
                       onFire,
                       onReturn,
                       editPermission,
                       editPerson = false,
                       onEditUser,
                       fireEmployeePermission,
                       returnEmployeePermission
                   }) => {
    const profileMe = useSelector((state) => state.profile.profileMe);

    const isMe = profileMe?.id === id;

    const {t} = useTranslation();
    return (
        <div className='employees' key={id}>
            <div className='employees__info'>
                <div className='employees__info-avatar'>
                    {avatar ? (
                        <img className='avatar-image' src={avatar} alt={name}/>
                    ) : position === 'spectator' ? (
                        <img className='avatar-image' src={AvatarSpectator} alt={name}/>
                    ) : (
                        <img className='avatar-image' src={AvatarUser} alt={name}/>
                    )}

                    {status === 'active' ? <div className='status active'/> : <div className='status'/>}
                </div>
                <div className='employees__info-user'>
                    <div className='employees__info-name' onClick={handleId}>
                        {name}
                    </div>
                    <div className='employees__info-role'>{position}</div>
                </div>
            </div>
            <div className='employees__details'>
                <div className='employees__details-rating'>
                    <Rating mark={mark}/>
                    <div className='rating-mini'>
                        <StarsIcon/>
                    </div>
                    {mark}/5
                </div>

                {!review && (
                    <div className='employees__details-work'>
                        В роботі: <span>{projectsAtWork}</span>
                    </div>
                )}

                <div className='btns'>
                    {status === 'active' && fireEmployeePermission && !isMe && (
                        <div className='employees__details-btn' onClick={() => onFire(employeeId)}>
                            <IconButtonMUI color={'inherit'} title={t('EmployeesInner.fire')}>
                                <ToReleaseIcon/>
                            </IconButtonMUI>
                        </div>
                    )}

                    {status === 'fired' && returnEmployeePermission && !isMe && (
                        <div className='employees__details-btn' onClick={() => onReturn(employeeId)}>
                            <IconButtonMUI color={'inherit'} title={t('EmployeesInner.return')}>
                                <UseAddIcon/>
                            </IconButtonMUI>
                        </div>
                    )}

                    {editPerson && (
                        <div
                            className='employees__details-btn'
                            onClick={() =>
                                onEditUser({
                                    id: id,
                                    name: name,
                                    avatar: avatar,
                                    email: email,
                                    phone: phone
                                })
                            }
                        >
                            <IconButtonMUI color={'inherit'} title={t('dictionaries.edit')}>
                                <SettingsIcon/>
                            </IconButtonMUI>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Employees;
